import React from 'react';
import PropTypes from 'prop-types';

import {Button} from 'views/components';
import {Print as PrintIcon} from 'views/icons';
import {Translate} from 'views/module';

import {useReactToPrint} from 'react-to-print';

const ReactToPrint = (props) => {
  const {
    children,
    documentTitle = 'Document',
    buttonProps = {},
    showIcon = true,
    customButton = null,
    onBeforePrint,
    onAfterPrint,
    printableRef,
    ...otherProps
  } = props;

  const internalRef = React.useRef(null);
  const contentRef = printableRef || internalRef;

  const handlePrint = useReactToPrint({
    contentRef,
    documentTitle,
    onBeforePrint,
    onAfterPrint,
    ...otherProps,
  });

  const handlePrintClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    handlePrint();
  };

  const renderButton = () => {
    if (customButton) {
      return React.cloneElement(customButton, {
        onClick: handlePrintClick,
      });
    }

    return (
      <Button
        onClick={handlePrintClick}
        variant="outlined"
        startIcon={showIcon ? <PrintIcon /> : null}
        {...buttonProps}
      >
        <Translate expression="generic.Print" />
      </Button>
    );
  };

  // If printableRef is provided, only render the button
  if (printableRef) {
    return renderButton();
  }

  // If no printableRef is provided, render both button and content
  return (
    <>
      {renderButton()}
      <div ref={contentRef}>
        {children}
      </div>
    </>
  );
};

ReactToPrint.propTypes = {
  children: PropTypes.node,
  documentTitle: PropTypes.string,
  buttonProps: PropTypes.object,
  showIcon: PropTypes.bool,
  customButton: PropTypes.element,
  onBeforePrint: PropTypes.func,
  onAfterPrint: PropTypes.func,
  printableRef: PropTypes.object,
};

export default ReactToPrint;
